import { render } from "./PlpViewOptions.vue?vue&type=template&id=f31830c0"
import script from "./PlpViewOptions.vue?vue&type=script&lang=js"
export * from "./PlpViewOptions.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__